import { Button, Card, Carousel, Col, Input, Layout, Row, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import HeaderFile from './Layout/HeaderFile';
import FooterFile from './Layout/FooterFile';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import SmoothScrollProvider from './Layout/SmoothScrollProvider';
import BlurText from './Layout/BlurText';
import { ParallaxBanner } from 'react-scroll-parallax';



const { Header, Content, Footer } = Layout;

const { Title, Text } = Typography;

const Work = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 770); // Set breakpoint for mobile
      };

      handleResize(); // Set initial state
      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    const [isBlurred, setIsBlurred] = useState(true);
    const [password, setPassword] = useState("");
    const correctPassword = "12345"; // Replace with your desired password
  
    const defaultLayoutPluginInstance = defaultLayoutPlugin();


    const handlePasswordSubmit = () => {
      if (password === correctPassword) {
        setIsBlurred(false);
      } else {
        alert("Incorrect password");
      }
    };

   // for the button download 
    const handleDownload = () => {
      const link = document.createElement("a");
      link.href = "/dummy.pdf"; // Path to your PDF file
      link.download = "dummy.pdf"; // The name the downloaded file will have
      link.click();
    };
    
    
  return (

    <Layout>
      <SmoothScrollProvider/>

    <Header className='header-style' >
      {/* Importing from the another component */}
      <HeaderFile/>
    </Header>

    <Content>
        
                  
           <div className='banner-tp'>
            <img src="/about-Frame.png" />
              <div className="banner-content">
                <img
                src="/frameImg.png"
                alt="Overlay Image"
                className='top-img'
                />
                <div className="image-content-dis">
                  <BlurText
                  text="Partners"
                  delay={150}
                  animateBy="words"
                  direction="top"
                  className="toptextone"  // example (if using Tailwind)
                  />
                  <BlurText
                  text="Stories, strategy and passion, builds partnerships"
                  delay={300}
                  animateBy="words"
                  direction="top"
                  />
              </div>
              </div>             
           </div>
        <Row className="work_tp_wrap contbfr" justify="center" align="middle" style={{padding: isMobile ? "0 5%" : "0 10%", background:"#fff"}}>
            <Col span={14} md={14} xs={24}>

            <p style={{fontSize: isMobile ? "14px" :"28px", margin:"0"}}>Let's Partner</p>
            <h1 className='headings'>
            Work With Us
            </h1>
              <p className="work-with-content"> Every journey has a story, and some of the best ones begin with the right partners. We love working with brands that believe in the spirit of adventure, the kind that values authenticity over perfection and stories over scripts. Our collaborations aren’t about picture perfect moments; they’re about real roads, honest experiences, and the magic that happens when purpose meets passion. Whether it’s testing gear, capturing the soul of a place, or creating content that inspires others to explore. We work with brands that ride the same road of curiosity, courage, and creativity.</p>

            </Col>
            <Col span={10} md={10} xs={24} style={{display:"flex", justifyContent:"center"}}>
            <img
                src="/work-with.png"
                alt="Logo" className='woirkbanner'
              
              />
            </Col>
        </Row>
 <div className='work-with-brands'>
  <p style={{ fontSize: isMobile ? "14px" : "28px", margin: "0" }}>
    Brand & Partnerships
  </p>

  <h1 className='headings'>
    Brands we've worked with
  </h1>

  {/* Desktop Layout */}
  {!isMobile && (
    <div
      className='brands_wrap'
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "20px",
      }}
    >
      <img src="/brand1.png" alt="Logo" className="brand-img" />
      <img src="/brand2.png" alt="Logo" className="brand-img" />
      <img src="/brand3.png" alt="Logo" className="brand-img" />
      <img src="/brand4.png" alt="Logo" className="brand-img" />
      <img src="/brand5.png" alt="Logo" className="brand-img" />
      <img src="/brand6.png" alt="Logo" className="brand-img" />
      <img src="/brand7.png" alt="Logo" className="brand-img" />
    </div>
  )}
  {/* Mobile Carousel */}
  {isMobile && (
    <Carousel autoplay autoplaySpeed={2500} dots={false}>      
      <div>
        <div className="brand-slide">
          <img src="/brand1.png" alt="Logo" className="brand-img" />
          <img src="/brand2.png" alt="Logo" className="brand-img" />
        </div>
      </div>
      <div>
        <div className="brand-slide">
          <img src="/brand3.png" alt="Logo" className="brand-img" />
          <img src="/brand4.png" alt="Logo" className="brand-img" />
        </div>
      </div>
      <div>
        <div className="brand-slide">
          <img src="/brand5.png" alt="Logo" className="brand-img" />
          <img src="/brand6.png" alt="Logo" className="brand-img" />
        </div>
      </div>

      <div>
        <div className="brand-slide">
          <img src="/brand7.png" alt="Logo" className="brand-img" />
        </div>
      </div>

    </Carousel>
  )}
</div>      
        <Row justify="center" align="middle" className='featuredprojectstext' style={{paddingTop:"3%"}}>
          <div className='work-with-brandsn'>
            <h1 className='camp-heading'>
              Featured Projects
            </h1>
          </div>
        </Row>
     
      

 
        <Row justify="center" align="middle" style={{padding: "3% 5% 0 5%", background:"#fff"}}>
          <Col span={12} md={12} xs={24} style={{display:"flex", justifyContent:"center"}}>
            <img
                src="/y-video.png"
                alt="Logo"
                style={{ width: "60%", marginTop:"20px", paddingBottom:"2rem"}}
              />
            </Col>
            <Col span={12} md={12} xs={24}>
            <h3 className='blog-text'>
            Decathlon Podcast
            </h3>
            <div style={{padding: "0rem 0 0 0rem",}}>            
            <p className="work-with-content"> 
              Decathlon India launched its first ever podcast, “Mountain Days,” a series that explored the many shades of outdoor adventure and travel.
Hosted by Mouna Nanaiah, the first creator to collaborate with Decathlon in this format, the seven episode series featured guests from diverse walks of life, from motorcyclists and trekkers to dog travelers and DIY hiking enthusiasts.
Each episode offered raw, insightful conversations about real experiences, inspiring listeners to step outside and explore.
Aired on YouTube, Mountain Days was widely appreciated for its authenticity, storytelling depth, and the way it celebrated the spirit of adventure in everyday explorers. 
            </p>            
            </div>
            </Col>            
        </Row>
       
        <Row className="vahn_caravan_wrap" justify="center" align="middle" style={{padding: "2% 5% 0 5%", background:"#fff"}}>
            <Col span={12} md={12} xs={24}>
            <h1 className='blog-text'>
            Travel With Vahn Caravan
            </h1>
            <div style={{padding: "0rem 0 0 0rem",}}>        
            <p className="work-with-content"> 
              In collaboration with Travel with Vahn, a caravan rental company operating Pan India, we set out on an unforgettable road trip along the west coast of India. Starting from Bangalore, to the hills of Agumbe, entering the coast till Goa. This 12 days life in a van was a beautiful mix of freedom and simplicity, waking up to ocean sunrises, cooking by the shore, and chasing sunsets that felt endless.
            </p>
            
            </div>
            </Col>
            <Col span={12} md={12} xs={24} style={{display:"flex", justifyContent:"center"}}>
            <img
                src="/caravan-post.png"
                alt="Logo"
                style={{ width: "60%", marginTop:"20px", paddingBottom:"2rem"}}
              />
            </Col>
        </Row>
    
        <Row justify="center" align="middle" style={{padding: "2% 5% 0 5%", background:"#fff"}}>
          <Col span={12} md={12} xs={24} style={{display:"flex", justifyContent:"center"}}>
            <img
                src="/y-videotw.png"
                alt="Logo"
                style={{ width: "60%", marginTop:"20px", paddingBottom:"2rem"}}
              />
            </Col>
            <Col span={12} md={12} xs={24} >
            <h1 className='blog-text'>
           Royal Enfield Global Launch
            </h1>
            <div style={{padding: "0rem 0 0 0rem",}}>
            
            <p className="work-with-content"> 
             Royal Enfield Himalayan had their global launch in November 2023. 80 global riders were invited to test the bike in the Himalayas.
Over two days a total of 350 kms were ridden, the route started from Manali towards Leh highway, crossed into Tandi and went off road. On second day the ride was towards the Chandratal road to Spiti (Which is seasonally a very tough road to ride in)
             </p>
            
            </div>
            </Col>            
        </Row>
      
        <Row justify="center" align="middle" className='work-with-brands' style={{paddingTop:"5%", display:"none",}}>
            <Col span={10} >
            <div>
            <Carousel infinite={true} autoplay={{ dotDuration: true }} autoplaySpeed={5000} arrows>
               <div >
                 <img
                   src="/proj-1.png"
                   alt="Logo"
                   style={{ width: "60%", height: "auto", }}
                 />
               </div>
               <div>
                 <img
                   src="/proj-2.png"
                   alt="Logo"
                   style={{ width: "60%", height: "auto", }}
                 />
               </div>
               <div>
                 <img
                   src="/proj-3.png"
                   alt="Logo"
                   style={{ width: "60%", height: "auto",  }}
                 />
               </div>
             </Carousel>
             </div>
            </Col>
            <Col span={10} >
             <h1 className='headings'>
             Featured Projects
             </h1>
             <div style={{padding: "3rem 0 0 5rem",}}>
             <p style={{fontSize: "28px", margin:"0", color:"#FFA321"}}>Perspiciatis unde </p>
             <p className="work-with-content"> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</p>
             <ul className="work-with-content">
                         <li>Sed ut perspiciatis unde</li>
                         <li>Omnis iste natus error </li>
                         <li>voluptatem accusantium</li>
                         <li>Doloremque  sit</li>
                     </ul>
             </div>
            </Col>
        </Row>
        
        
        {!isMobile && (
        <div style={{padding: "0 5% 0 5%", background:"#fff"}}>
            <Carousel className='test-cor' infinite={true} arrows>
              <div>
                 <Row justify="space-evenly" align="middle" style={{ marginTop: "3rem" }}>
                   <Col span={10} className="test-style">
                     <Card className="test-card" >
                       <div className='test-card-style'>
                         <img
                           src="Saif_Ahmed.png"
                           alt="Profile" className='test-card-img'
                         />
                       </div>
                       <p style={{ padding: "0 5%", marginTop: "4rem" }}>
                       Working with the Rucksackdiaries team has been an absolute pleasure. I’ve collaborated with multiple creative partners, but Mouna & Shyams' creative approach truly stands out. From ideation to execution, the entire process was seamless, highly professional, and refreshingly creative.
They understood our vision quickly and translated it into engaging, high-quality content that resonated perfectly with our audience. What impressed us most was their ability to balance storytelling with brand objectives without any friction. Not to mention the fun meets we'd throughout the whole process!
If you're looking for a team that’s reliable, creative, and effortless to work with, Rucksack Diaries is a fantastic choice!
 </p>
                       <b>Saif Ahmed - Designation - COO RoadBee</b>
                     </Card>
                   </Col>
                   <Col span={10} className="test-style">
                     <Card className="test-card" >
                       <div className='test-card-style'>
                         <img
                           src="Ajay_Gowda.png"
                           alt="Profile" className='test-card-img'
                         />
                       </div>
                       <p style={{ padding: "0 2%", marginTop: "4rem" }}>
                       I’ve been working with Mouna for the past 6 months now, and it’s been a really smooth experience collaborating with her across multiple projects. She’s been very supportive, proactive, and easy to coordinate with throughout the process.
We worked together on campaigns for brands like KTM and Motul, and she handled things very efficiently — especially when it came to managing timelines, coordinating requirements, and keeping communication clear between teams.
What I personally appreciate most is her positive attitude and readiness to step in whenever needed. She brings a lot of clarity and reliability to the work, which makes collaboration much easier.
It’s been great working with her over these last few months, and I’m looking forward to working together on more projects ahead 
 </p>
                       <b>Ajay Gowda - Assistant Manager, Community & Client Engagement</b>
                     </Card>
                   </Col>
                </Row>
              </div>
              <div>
                 <Row justify="space-evenly" align="middle" style={{ marginTop: "3rem" }}>
                   <Col span={10} className="test-style">
                     <Card className="test-card" >
                       <div className='test-card-style'>
                         <img
                           src="Saif_Ahmed.png"
                           alt="Profile" className='test-card-img'
                         />
                       </div>
                       <p style={{ padding: "0 5%", marginTop: "4rem" }}>
                       Working with the Rucksackdiaries team has been an absolute pleasure. I’ve collaborated with multiple creative partners, but Mouna & Shyams' creative approach truly stands out. From ideation to execution, the entire process was seamless, highly professional, and refreshingly creative.
They understood our vision quickly and translated it into engaging, high-quality content that resonated perfectly with our audience. What impressed us most was their ability to balance storytelling with brand objectives without any friction. Not to mention the fun meets we'd throughout the whole process!
If you're looking for a team that’s reliable, creative, and effortless to work with, Rucksack Diaries is a fantastic choice! </p>
                        <b>Saif Ahmed - Designation - COO RoadBee</b>
                     </Card>
                   </Col>
                   <Col span={10} className="test-style">
                     <Card className="test-card" >
                       <div className='test-card-style'>
                         <img
                           src="Ajay_Gowda.png"
                           alt="Profile" className='test-card-img'
                         />
                       </div>
                       <p style={{ padding: "0 2%", marginTop: "4rem" }}>
                       I’ve been working with Mouna for the past 6 months now, and it’s been a really smooth experience collaborating with her across multiple projects. She’s been very supportive, proactive, and easy to coordinate with throughout the process.
We worked together on campaigns for brands like KTM and Motul, and she handled things very efficiently — especially when it came to managing timelines, coordinating requirements, and keeping communication clear between teams.
What I personally appreciate most is her positive attitude and readiness to step in whenever needed. She brings a lot of clarity and reliability to the work, which makes collaboration much easier.
It’s been great working with her over these last few months, and I’m looking forward to working together on more projects ahead  </p>
                       <b>Ajay Gowda - Assistant Manager, Community & Client Engagement</b>
                     </Card>
                   </Col>
                </Row>
              </div>
            </Carousel>
        </div>
        )}
        {isMobile && (
          <div style={{padding: "0 5%"}}>
              <Carousel infinite={true} autoplay={{ dotDuration: true }} autoplaySpeed={5000} arrows>
                <div >
                <Card className="test-card" >
                      <div className='test-card-style'>
                         <img
                           src="Saif_Ahmed.png"
                           alt="Profile" className='test-card-img'
                         />
                       </div>
                       <p style={{ padding: "0 5%", lineHeight:"18px", marginTop: "2rem", fontSize:"10px" }}>
                       Working with the Rucksackdiaries team has been an absolute pleasure. I’ve collaborated with multiple creative partners, but Mouna & Shyams' creative approach truly stands out. From ideation to execution, the entire process was seamless, highly professional, and refreshingly creative.
They understood our vision quickly and translated it into engaging, high-quality content that resonated perfectly with our audience. What impressed us most was their ability to balance storytelling with brand objectives without any friction. Not to mention the fun meets we'd throughout the whole process!
If you're looking for a team that’s reliable, creative, and effortless to work with, Rucksack Diaries is a fantastic choice! </p>
                       <b style={{fontSize:"12px"}}>Saif Ahmed - Designation - COO RoadBee</b>
                     </Card>
                </div>
                <div>
                <Card className="test-card" >
                       <div className='test-card-style'>
                         <img
                           src="Ajay_Gowda.png"
                           alt="Profile" className='test-card-img'
                         />
                       </div>
                       <p style={{ padding: "0 5%", lineHeight:"18px", marginTop: "2rem", fontSize:"10px"}}>
                      I’ve been working with Mouna for the past 6 months now, and it’s been a really smooth experience collaborating with her across multiple projects. She’s been very supportive, proactive, and easy to coordinate with throughout the process.
We worked together on campaigns for brands like KTM and Motul, and she handled things very efficiently — especially when it came to managing timelines, coordinating requirements, and keeping communication clear between teams.
What I personally appreciate most is her positive attitude and readiness to step in whenever needed. She brings a lot of clarity and reliability to the work, which makes collaboration much easier.
It’s been great working with her over these last few months, and I’m looking forward to working together on more projects ahead 
 </p>
                       <b style={{fontSize:"12px"}}>Ajay Gowda - Assistant Manager, Community & Client Engagement</b>
                     </Card>
                </div>
                
              </Carousel>
          </div>
        )}
        <div style={{padding: "5% 10%", background:"#fff"}}>
        <div className='hidden-card'>
           {/* Blur Background */}
           {isBlurred && (
             <div className='hidden-card-style'>
               <div style={{ textAlign: "center" }} >
                 <h2>Enter password to access full media kit</h2>
                 <Input.Password
                   value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   placeholder="Enter password"
                   style={{ marginBottom: "1rem" }}
                 />
                 <Button className='hidden-card-button' type="primary" onClick={handlePasswordSubmit} block>
                   Submit
                 </Button>
               </div>
             </div>
           )}
           {/* Main Content */}
           <div className='d_hidden-card-wrp'
             style={{
               padding: "2rem",
               filter: isBlurred ? "blur(30px)" : "none",
               transition: "filter 0.3s ease",
               height: "100%",
             }}
           >
                {/* <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                <Viewer
                  fileUrl="/dummy.pdf" // Path to your PDF file
                  plugins={[defaultLayoutPluginInstance]}
                />
              </Worker> */}
              <Button onClick={handleDownload} className='about-buton-two'>
              Download PDF
            </Button>
           </div>
         </div>
         </div>
    </Content>
    <Footer style={{ position: 'relative', overflow: 'hidden' }}>
        <FooterFile/>
      </Footer>
    </Layout>
  )
}

export default Work